import { object, oneOf } from 'prop-types';

import { getSettings } from 'utils/settings';

function Logo({ style, variant }) {
  const logoSettings = getSettings('logo', {});
  const companyLogos = {
    imagotipo: logoSettings.isotipo,
    'imagotipo-horizontal': logoSettings.light,
    'imagotipo-horizontal-dark': logoSettings.dark,
  };

  return (<>
    <img
      alt="Company logo"
      src={companyLogos[variant]}
      style={{
        height: '100px',
        ...style,
      }}
    />
  </>);
}

Logo.defaultProps = {
  company: 'a55',
  variant: 'imagotipo-horizontal-dark',
};

Logo.propTypes = {
  style: object,
  variant: oneOf([
    'imagotipo',
    'imagotipo-horizontal',
    'imagotipo-horizontal-dark',
  ]),
};

export default Logo;
